import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAllOverview = createAsyncThunk('overview/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/property-schedule/get-schedule-calendar`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allOverview: [],
  error: null
}

const OverviewSlice = createSlice({
  name: 'overview',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllOverview.pending, (state) => {
        state.isLoading = true,
        state.allOverview = []
      })
      .addCase(getAllOverview.fulfilled, (state, action) => {
        state.isLoading = false
        state.allOverview = action.payload?.data?.data
      })
      .addCase(getAllOverview.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default OverviewSlice.reducer
